/** 각 카드 → 고유 렌더러 (풀 사이트 5종 + 동적 테마 10종) */
export const SITE_RENDERERS = {
  "gimpo-woori": "gimpo-woori",
  "hi-medical": "hi-medical",
  "green-dental": "study",
  "prime-checkup": "pulse",
  "joy-obgyn": "bloom",
  "clear-eye": "nova",
  "bone-ortho": "ops",
  "skin-aesthetic": "luxe",
  "kids-pediatric": "meri",
  "han-heart": "marble",
  "neuro-brain": "code",

  nexus: "nexus",
  "atlas-logistics": "nova",
  "vertex-bio": "study",
  "stellar-media": "meri",
  "quantum-tech": "code",
  "green-energy": "bloom",
  "harbor-trade": "pulse",
  "prime-consulting": "luxe",
  "forge-mfg": "ops",
  "summit-holdings": "marble",

  "morning-brew": "brew",
  "matcha-house": "bloom",
  "roast-lab": "spiral-roast",
  "sweet-bean": "meri",
  "urban-drip": "pulse",
  "slow-cup": "luxe",
  "forest-bean": "study",
  "drip-line": "nova",
  "cream-top": "roast",
  "night-owl": "ops",

  hanokdam: "hanok",
  "sushi-gin": "luxe",
  "pasta-bella": "meri",
  "spice-road": "nova",
  "bbq-fire": "roast",
  "ramen-yoko": "ops",
  "brunch-table": "bloom",
  "wine-cellar": "marble",
  "vegan-leaf": "study",

  "first-digital": "bank",
  "city-bank": "marble",
  "regional-trust": "study",
  "capital-invest": "luxe",
  "savings-mutual": "bloom",
  "union-credit": "meri",
  "global-finance": "pulse",
  "youth-bank": "nova",
  "senior-care": "meri",
  "fintech-lab": "code",
};

export function getSiteRenderer(industry, demoId) {
  return SITE_RENDERERS[demoId] ?? "nova";
}
